import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import compact from 'lodash/compact';
import { Flex, Text } from 'roo-ui/components';
import { QFF_SIGNUP_URL } from 'config';
import {
  getTitle,
  getFirstName,
  getLastName,
  getMembershipTier,
  getPointsBalance,
  getIsAuthenticated,
  getMemberId,
} from 'store/user/userSelectors';
import FormatNumber from 'components/formatters/FormatNumber';
import { MembershipTier, StyledText, JoinLink, HoveredText } from './primitives';

const AuthenticationDetailsPhone = () => {
  const isAuthenticated = useSelector(getIsAuthenticated);
  const title = useSelector(getTitle);
  const firstName = useSelector(getFirstName);
  const lastName = useSelector(getLastName);
  const membershipTier = useSelector(getMembershipTier);
  const pointsBalance = useSelector(getPointsBalance);
  const memberId = useSelector(getMemberId);

  return (
    <Fragment>
      {isAuthenticated && (
        <Flex flexDirection="column" color="white" justifyContent="flex-start">
          <StyledText data-hj-suppress data-testid="member-name-id">
            {compact([title, firstName, lastName]).join(' ')} ({memberId})
          </StyledText>
          <Flex flexWrap="wrap">
            <MembershipTier data-testid="member-tier">{membershipTier} Frequent Flyer</MembershipTier>
            <StyledText mx={1}>-</StyledText>
            <StyledText data-testid="member-points-balance">
              <FormatNumber number={pointsBalance} /> points
            </StyledText>
          </Flex>
        </Flex>
      )}
      {!isAuthenticated && (
        <Flex textAlign="left" pr={4} data-testid="not-auth-wrapper">
          <JoinLink href={`${QFF_SIGNUP_URL}?thirdParty=hooroos`} data-testid="sign-up-link">
            <Text>Not a member? </Text>
            <HoveredText>Join now</HoveredText>
          </JoinLink>
        </Flex>
      )}
    </Fragment>
  );
};

export default AuthenticationDetailsPhone;
